import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { forkJoin } from 'rxjs'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { MatTabsModule } from '@angular/material/tabs'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatSelectModule } from '@angular/material/select'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTableModule } from '@angular/material/table'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { DecimalPipe, NgClass } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PassageiroItemContratoService } from '../../../core/services/passageiro-item-contrato/passageiro-item-contrato.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { StretchTypeService } from '../../../core/services/stretch/stretch-type/stretch-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ProposalItemService } from '../../../core/services/proposal/proposal-item/proposal-item.service'
import { ContractItemService } from '../../../core/services/contract/contract-item/contract-item.service'
import {
  ItemProposalCreateFormComponent,
} from '../../proposal/item-proposal-create/item-proposal-create-form/item-proposal-create-form.component'
import { TableListOSComponent } from '../../../shared/components/table-list-os/table-list-os.component'
import { PassengerEditLogisticsComponent } from '../../passengers/passengers-edit-logistics/passengers-edit-logistics.component'
import moment from 'moment'

interface PassengerGroup {
  label: string
  passengers: any[]
  expanded: boolean
}

@Component({
  selector: 'logistics-contract-item-create',
  standalone: true,
  imports: [
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgClass,
    DecimalPipe,
    FormsModule,
    TableListOSComponent,
    MatSlideToggle,
    PassengerEditLogisticsComponent,
  ],
  templateUrl: './logistics-contract-item-create.component.html',
  styleUrl: './logistics-contract-item-create.component.scss',
})
export class LogisticsContractItemCreateComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  // ── Passageiros ─────────────────────────────────────────────────────────────
  allPassengers: any[] = []
  passengerGroups: PassengerGroup[] = []
  loadingPassengers = false
  selectedPassengerIds = new Set<any>()

  groupBy: 'aeroporto' | 'endereco' = 'aeroporto'
  sentido: 'origem' | 'destino' | 'ambos' = 'ambos'
  statusVooFiltro: string = 'todos'
  toleranceMinutes = 15
  groupByDate = true

  passengerColumns = ['select', 'nome', 'documento', 'trecho', 'cia', 'hora', 'voo', 'acoes']

  // ── Validação ─────────────────────────────────────────────────────────────
  validacao: { discrepanciasQuantidade: any[]; discrepanciasTrecho: any[] } | null = null
  loadingValidacao = false
  validacaoError = false
  validacaoQuantidadeCols: string[] = []
  validacaoTrechoCols: string[] = []

  // ── Itens Proposta tab ─────────────────────────────────────────────────────

  // Trecho form
  trechoForm = {
    dataInicio: '',
    dataFim: '',
    horaSaida: '',
    horaPrevista: '',
    tempoPrevisto: '',
    tipoTrechoId: null as number | null,
    tipoVeiculoId: null as number | null,
    tipoMotoristaId: null as number | null,
    kmPrevisto: null as number | null,
    observacao: '',
  }
  stretchTypes: any[] = []
  loadingStretchTypes = false

  // Itinerários
  itinerarios: any[] = []
  showItinerarioForm = false
  itinerarioEditIdx: number | null = null
  itinerarioForm = {
    local: '',
    cep: '',
    logradouro: '',
    numero: '',
    bairro: '',
    cidade: '',
    areaTarifaria: 'Fora',
    trecho: 'O',
  }
  itinerarioColumns = ['local', 'cep', 'logradouro', 'numero', 'bairro', 'cidade', 'areaTarifaria', 'acoes']
  itinerarioColumnsEmergencial = ['local', 'cidade', 'trecho', 'acoes']

  // Proposal items search
  proposalSearch = {
    itemPropostaId: null as number | null,
    origemCidade: '',
    origemEstado: '',
    destinoCidade: '',
    destinoEstado: '',
    descricaoTipoServico: '',
    descricaoServico: '',
    tipoMotoristaId: null as number | null,
    tipoVeiculoId: null as number | null,
    pax: null as number | null,
    dataInicio: '',
    dataFinal: '',
    tipoTrechoId: null as number | null,
  }
  proposalItems: any[] = []
  loadingProposalItems = false
  proposalOrderBy = 'cidadeOrigem:asc'
  proposalPage = 1
  proposalRows = 15
  proposalTotalRows = 0
  selectedProposalItem: any = null
  proposalColumns = ['select', 'origem', 'destino', 'servico', 'veiculo', 'pax', 'valor', 'valorExtra']
  proposalTableColumns: any[] = [
    { keyColumn: 'selecionado',            key: '_selecionadoLabel',          description: ''           },
    { keyColumn: 'origemDestinoLogistica', key: 'origemDestinoLogistica',     description: 'Trecho'     },
    { keyColumn: 'servico',               key: 'descricaoServico',            description: 'Serviço'    },
    { keyColumn: 'veiculo',               key: 'descricaoTipoVeiculo',        description: 'Veículo'    },
    { keyColumn: 'pax',                   key: 'quantidadePassageiros',       description: 'Pax'        },
    { keyColumn: 'valor',                 key: '_valorFormatado',             description: 'Valor'      },
    { keyColumn: 'valorExtra',            key: '_valorExtraFormatado',        description: 'Valor Extra'},
    { keyColumn: 'action',                key: { selectSingle: true },        description: ''           },
  ]
  proposalSorts = [
    { id: 'cidadeOrigem:asc', description: 'Cidade origem ASC' },
    { id: 'cidadeDestino:asc', description: 'Cidade destino ASC' },
    { id: 'valor:asc', description: 'Valor ASC' },
    { id: 'pax:asc', description: 'Pax ASC' },
  ]

  savingItem = false
  isEmergencial = false
  custoEmergencial: number | null = null

  // ── Itens Logística ────────────────────────────────────────────────────────
  contractItems: any[] = []
  loadingContractItems = false
  contractItemPage = 1
  contractItemRows = 10
  contractItemTotalRows = 0
  anyItemCreated = false

  driverTypes: any[] = []
  vehicleTypes: any[] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LogisticsContractItemCreateComponent>,
    private dialog: MatDialog,
    private passengerService: PassengerService,
    private passageiroItemContratoService: PassageiroItemContratoService,
    private snackbar: SnackbarCustomService,
    private stretchTypeService: StretchTypeService,
    private driverTypeService: DriverTypeService,
    private vehicleTypeService: VehicleTypeService,
    private proposalItemService: ProposalItemService,
    private contractItemService: ContractItemService,
  ) {}

  ngOnInit() {
    this.loadPassengers()
    this.loadStretchTypes()
    this.loadContractItems()
    this.loadSelectData()
    this.fetchProposalItems()
  }

  checkEmergencial() {
    const data = this.trechoForm.dataInicio
    const hora = this.trechoForm.horaSaida
    if (!data || !hora) return
    const dt = moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm')
    if (dt.isValid()) {
      this.isEmergencial = dt.diff(moment(), 'hours') < 24
    }
  }

  loadSelectData() {
    this.driverTypeService.listDriverType().subscribe({
      next: (res: any) => { this.driverTypes = res.data || [] },
      error: () => {},
    })
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (res: any) => { this.vehicleTypes = res.data || [] },
      error: () => {},
    })
  }

  close() {
    this.dialogRef.close()
  }

  // ── Passageiros ────────────────────────────────────────────────────────────

  loadPassengers() {
    this.loadingPassengers = true
    this.passageiroItemContratoService.getDisponiveis(this.data.id).subscribe({
      next: (res: any) => {
        this.allPassengers = res.data || []
        this.applyGrouping()
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar os passageiros disponíveis.')
        this.loadingPassengers = false
      },
      complete: () => { this.loadingPassengers = false },
    })
  }

  loadValidacao() {
    this.loadingValidacao = true
    this.validacaoError = false
    this.passageiroItemContratoService.getValidacaoLogistica(this.data.id).subscribe({
      next: (res: any) => {
        this.validacao = res.data ?? res ?? null
        if (this.validacao) {
          this.validacaoQuantidadeCols = this.validacao.discrepanciasQuantidade?.length
            ? Object.keys(this.validacao.discrepanciasQuantidade[0])
            : []
          this.validacaoTrechoCols = this.validacao.discrepanciasTrecho?.length
            ? Object.keys(this.validacao.discrepanciasTrecho[0])
            : []
        }
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar a validação logística.')
        this.loadingValidacao = false
        this.validacaoError = true
      },
      complete: () => { this.loadingValidacao = false },
    })
  }

  togglePassenger(passenger: any) {
    const id = passenger.id ?? passenger.passageiroId
    if (this.selectedPassengerIds.has(id)) {
      this.selectedPassengerIds.delete(id)
    } else {
      this.selectedPassengerIds.add(id)
    }
  }

  toggleGroup(group: PassengerGroup) {
    const allSelected = group.passengers.every(p => this.selectedPassengerIds.has(p.id ?? p.passageiroId))
    if (allSelected) {
      group.passengers.forEach(p => this.selectedPassengerIds.delete(p.id ?? p.passageiroId))
    } else {
      group.passengers.forEach(p => this.selectedPassengerIds.add(p.id ?? p.passageiroId))
    }
  }

  isSelected(p: any): boolean {
    return this.selectedPassengerIds.has(p.id ?? p.passageiroId)
  }

  isGroupAllSelected(group: PassengerGroup): boolean {
    return group.passengers.length > 0 && group.passengers.every(p => this.selectedPassengerIds.has(p.id ?? p.passageiroId))
  }

  isGroupPartialSelected(group: PassengerGroup): boolean {
    const n = group.passengers.filter(p => this.selectedPassengerIds.has(p.id ?? p.passageiroId)).length
    return n > 0 && n < group.passengers.length
  }

  get selectedCount(): number {
    return this.selectedPassengerIds.size
  }

  clearSelection() {
    this.selectedPassengerIds.clear()
  }

  applyGrouping() {
    let passengers = [...this.allPassengers]

    if (this.sentido === 'origem') {
      passengers = passengers.filter(p => [1, 3, 5].includes(p.tipoTrechoId ?? p.tipo_trecho_id))
    } else if (this.sentido === 'destino') {
      passengers = passengers.filter(p => [2, 4, 6].includes(p.tipoTrechoId ?? p.tipo_trecho_id))
    }

    if (this.statusVooFiltro !== 'todos') {
      passengers = passengers.filter(p => {
        const s = ((p.statusVooDescricao ?? p.status_voo_descricao) ?? '').toLowerCase()
        return s.includes(this.statusVooFiltro)
      })
    }

    const groups = new Map<string, any[]>()
    const noData: any[] = []

    for (const p of passengers) {
      const key = this.buildGroupKey(p)
      if (!key) { noData.push(p); continue }
      if (!groups.has(key)) groups.set(key, [])
      groups.get(key)!.push(p)
    }

    const result: PassengerGroup[] = []
    groups.forEach((pax, label) => result.push({ label, passengers: pax, expanded: true }))
    if (noData.length > 0) result.push({ label: 'Sem dados suficiente', passengers: noData, expanded: true })

    result.sort((a, b) => {
      if (a.label === 'Sem dados suficiente') return 1
      if (b.label === 'Sem dados suficiente') return -1
      return a.label.localeCompare(b.label)
    })

    this.passengerGroups = result
  }

  private buildGroupKey(p: any): string | null {
    const data = p.data
    const hora = p.hora
    let location: string | null = null

    if (this.groupBy === 'aeroporto') {
      location = p.destinoOrigemAero ?? p.destino_origem_aero ?? null
    } else {
      const bairro = p.bairroPap ?? p.bairro_pap ?? ''
      const cidade = p.cidadePap ?? p.cidade_pap ?? ''
      location = [bairro, cidade].filter(Boolean).join(', ') || null
    }

    if (!location) return null
    if (this.groupByDate && !data) return null

    let timeLabel = hora ?? '00:00'
    if (hora) {
      const parts = hora.split(':').map(Number)
      const totalMins = parts[0] * 60 + (parts[1] ?? 0)
      const rounded = Math.floor(totalMins / this.toleranceMinutes) * this.toleranceMinutes
      timeLabel = `${String(Math.floor(rounded / 60)).padStart(2, '0')}:${String(rounded % 60).padStart(2, '0')}`
    }

    return this.groupByDate
      ? `${location} | ${data} | ${timeLabel}`
      : `${location} | ${timeLabel}`
  }

  editPassenger(p: any) {
    const dialogRef = this.dialog.open(PassengerEditLogisticsComponent, {
      data: { item: p, edit: true, idContrato: this.data.id, alert: p.mensagemCamposFaltantes ?? null },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.response.subscribe(() => this.loadPassengers())
  }

  viewPassenger(p: any) {
    this.dialog.open(PassengerEditLogisticsComponent, {
      data: { item: p, edit: false, idContrato: this.data.id },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
  }

  abrirVoo(voo: string) {
    this.snackbar.info(`Voo: ${voo}`)
  }

  getStatusVoo(p: any): { label: string; css: string } {
    const s = ((p.statusVooDescricao ?? p.status_voo_descricao) ?? '').toLowerCase()
    if (s.includes('cancelado'))  return { label: p.statusVooDescricao ?? 'Cancelado',  css: 'badge-red' }
    if (s.includes('atrasado'))   return { label: p.statusVooDescricao ?? 'Atrasado',   css: 'badge-yellow' }
    if (s.includes('no hor'))     return { label: p.statusVooDescricao ?? 'No horário', css: 'badge-green' }
    if (s)                        return { label: p.statusVooDescricao,                 css: 'badge-orange' }
    return { label: '-', css: '' }
  }

  getRowClass(_p: any): string {
    return ''
  }

  // ── Stretch types ──────────────────────────────────────────────────────────

  loadStretchTypes() {
    this.loadingStretchTypes = true
    this.stretchTypeService.listStretchType().subscribe({
      next: (res: any) => { this.stretchTypes = res.data || [] },
      error: () => { this.loadingStretchTypes = false },
      complete: () => { this.loadingStretchTypes = false },
    })
  }

  // ── Itinerários ────────────────────────────────────────────────────────────

  openAddItinerario() {
    this.itinerarioEditIdx = null
    this.itinerarioForm = { local: '', cep: '', logradouro: '', numero: '', bairro: '', cidade: '', areaTarifaria: 'Fora', trecho: 'O' }
    this.showItinerarioForm = true
  }

  editItinerario(idx: number) {
    this.itinerarioForm = { ...this.itinerarios[idx] }
    this.itinerarioEditIdx = idx
    this.showItinerarioForm = true
  }

  removeItinerario(idx: number) {
    this.itinerarios.splice(idx, 1)
    this.itinerarios = [...this.itinerarios]
  }

  saveItinerario() {
    if (this.itinerarioEditIdx !== null) {
      this.itinerarios[this.itinerarioEditIdx] = { ...this.itinerarioForm }
      this.itinerarios = [...this.itinerarios]
    } else {
      this.itinerarios = [...this.itinerarios, { ...this.itinerarioForm }]
    }
    this.showItinerarioForm = false
    this.itinerarioEditIdx = null
  }

  cancelItinerario() {
    this.showItinerarioForm = false
    this.itinerarioEditIdx = null
  }

  // ── Proposal items search ──────────────────────────────────────────────────

  searchProposalItems() {
    this.proposalPage = 1
    this.fetchProposalItems()
  }

  resetProposalSearch() {
    this.proposalSearch = {
      itemPropostaId: null,
      origemCidade: '',
      origemEstado: '',
      destinoCidade: '',
      destinoEstado: '',
      descricaoTipoServico: '',
      descricaoServico: '',
      tipoMotoristaId: null,
      tipoVeiculoId: null,
      pax: null,
      dataInicio: '',
      dataFinal: '',
      tipoTrechoId: null,
    }
    this.selectedProposalItem = null
    this.proposalPage = 1
    this.fetchProposalItems()
  }

  fetchProposalItems() {
    this.loadingProposalItems = true
    const s = this.proposalSearch
    const model = {
      itemPropostaId: s.itemPropostaId || 0,
      origemId: 0,
      descricaoOrigem: '',
      origemCidade: s.origemCidade || '',
      origemEstado: s.origemEstado || '',
      destinoId: 0,
      descricaoDestino: '',
      destinoCidade: s.destinoCidade || '',
      destinoEstado: s.destinoEstado || '',
      tipoServicoId: 0,
      descricaoTipoServico: s.descricaoTipoServico || '',
      servicoId: 0,
      descricaoServico: s.descricaoServico || '',
      propostaId: this.data.propostaId ?? 0,
      tipoMotoristaId: s.tipoMotoristaId || 0,
      tipoVeiculoId: s.tipoVeiculoId || 0,
      contratoId: this.data.id ?? null,
      pax: s.pax || 0,
      dataInicio: s.dataInicio || '',
      dataFinal: s.dataFinal || '',
      tipoTrechoId: s.tipoTrechoId || 0,
    }
    this.proposalItemService.searchPagedByProposalLogistics(
      this.proposalPage,
      this.proposalRows,
      model,
      this.proposalOrderBy,
    ).subscribe({
      next: (res: any) => {
        this.proposalItems = (res.data || []).map((item: any) => this.treatProposalItem(item))
        this.proposalTotalRows = res.totalItens ?? 0
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar os itens de proposta.')
        this.loadingProposalItems = false
      },
      complete: () => { this.loadingProposalItems = false },
    })
  }

  onProposalPageEvent(event: PageEvent) {
    this.proposalPage = event.pageIndex + 1
    this.proposalRows = event.pageSize
    this.fetchProposalItems()
  }

  selectProposalItem(item: any) {
    const wasSelected = this.selectedProposalItem?.id === item.id
    this.selectedProposalItem = wasSelected ? null : item
    this.proposalItems = this.proposalItems.map(i => ({
      ...i,
      _selecionadoLabel: this.selectedProposalItem?.id === i.id ? '✓' : '',
    }))
    if (!wasSelected && item) {
      this.autoFillTrechoFromItem(item)
    }
  }

  private autoFillTrechoFromItem(item: any) {
    const toDateInput = (dd_mm_yyyy: string | null): string => {
      if (!dd_mm_yyyy) return ''
      const parts = dd_mm_yyyy.split('/')
      return parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : ''
    }
    const toTimeInput = (hh_mm_ss: string | null): string => {
      if (!hh_mm_ss) return ''
      return hh_mm_ss.substring(0, 5)
    }
    this.trechoForm = {
      ...this.trechoForm,
      dataInicio: toDateInput(item.dataInicio),
      dataFim: toDateInput(item.dataFinal),
      horaSaida: toTimeInput(item.horaInicio),
      horaPrevista: toTimeInput(item.horaFinal),
    }
    this.checkEmergencial()
  }

  private treatProposalItem(item: any): any {
    return {
      ...item,
      origemDestinoLogistica: `Origem\nCidade: ${item.cidadeOrigem || '-'}\nEstado: ${item.estadoOrigem || '-'}\nDestino\nCidade: ${item.cidadeDestino || '-'}\nEstado: ${item.estadoDestino || '-'}`,
      _valorFormatado: this.formatarValor(item.valorVenda),
      _valorExtraFormatado: this.formatarValor(item.custoKmExtra),
      _selecionadoLabel: this.selectedProposalItem?.id === item.id ? '✓' : '',
    }
  }

  private formatarValor(valor: any): string {
    if (valor == null) return '-'
    const n = typeof valor === 'number' ? valor : parseFloat(valor)
    if (isNaN(n)) return '-'
    return `R$ ${n.toFixed(2).replace('.', ',')}`
  }

  isProposalItemSelected(item: any): boolean {
    return this.selectedProposalItem?.id === item.id
  }

  openAddProposalItem() {
    const ref = this.dialog.open(ItemProposalCreateFormComponent, {
      data: {
        edit: false,
        idClient: this.data.idCliente,
        period: { dataInicio: this.data.dataInicio, dataFim: this.data.dataFim },
      },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    ref.componentInstance.response.subscribe((ok: boolean) => {
      if (ok) this.fetchProposalItems()
    })
  }

  // ── Create item (stage to localStorage) ───────────────────────────────────

  criarItem() {
    if (!this.selectedProposalItem) {
      this.snackbar.error('Selecione um item de proposta antes de criar.')
      return
    }

    const passageiros = Array.from(this.selectedPassengerIds).map(id => ({ id }))
    const selectedStretchType = this.stretchTypes.find(s => s.id === this.trechoForm.tipoTrechoId)
    const dataInicioFormatted = this.trechoForm.dataInicio
      ? moment(this.trechoForm.dataInicio, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : null
    const dataFinalFormatted = this.trechoForm.dataFim
      ? moment(this.trechoForm.dataFim, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : null

    const model = {
      contratoId: this.data.id,
      itemPropostaId: Number(this.selectedProposalItem.id),
      isEmergencial: false,
      custoEmergencial: 0,
      origemId: this.selectedProposalItem.origemId ?? 0,
      destinoId: this.selectedProposalItem.destinoId ?? 0,
      tipoServicoId: this.selectedProposalItem.tipoServicoId ?? null,
      servicoId: this.selectedProposalItem.servicoId ?? null,
      tipoVeiculoId: this.selectedProposalItem.tipoVeiculoId ?? null,
      tipoMotoristaId: this.selectedProposalItem.tipoMotoristaId ?? null,
      tipoTrechoId: this.trechoForm.tipoTrechoId ?? null,
      dataInicio: dataInicioFormatted,
      horaInicio: this.formatHora(this.trechoForm.horaSaida),
      dataFinal: dataFinalFormatted,
      horaFinal: this.formatHora(this.trechoForm.horaPrevista),
      kmPrevisto: this.trechoForm.kmPrevisto ?? 0,
      tempoPrevisto: this.formatHora(this.trechoForm.tempoPrevisto),
      observacao: this.trechoForm.observacao || '',
      mostrarObsPdf: '',
      valorTarifario: 0,
      valorProposta: this.selectedProposalItem.valorVenda ?? 0,
      valorCompra: 0,
      passageiro: passageiros,
      temPassageiro: passageiros.length > 0 ? 'S' : 'N',
      itinerario: this.itinerarios.map(iti => ({
        contratoItemId: '00000000-0000-0000-0000-000000000000',
        localParada: iti.local || '',
        cep: iti.cep || '',
        logradouro: iti.logradouro || '',
        numero: iti.numero || '',
        bairro: iti.bairro || '',
        complemento: '',
        descricao: '',
        cidade: iti.cidade || '',
        estado: '',
        latitude: 0,
        longitude: 0,
        trecho: '',
        areaTarifario: iti.areaTarifaria === 'Dentro' ? 'S' : 'N',
      })),
    }

    const display = {
      tipoServico: this.selectedProposalItem.descricaoTipoServico || '-',
      servico: this.selectedProposalItem.descricaoServico || '-',
      veiculo: this.selectedProposalItem.descricaoTipoVeiculo || '-',
      motorista: this.selectedProposalItem.descricaoTipoMotorista || '-',
      valor: this.selectedProposalItem.valorVenda ?? 0,
      cidadeOrigem: this.selectedProposalItem.cidadeOrigem || '-',
      estadoOrigem: this.selectedProposalItem.estadoOrigem || '-',
      cidadeDestino: this.selectedProposalItem.cidadeDestino || '-',
      estadoDestino: this.selectedProposalItem.estadoDestino || '-',
      dataInicio: dataInicioFormatted || '-',
      horaInicio: this.trechoForm.horaSaida || '-',
      dataFinal: dataFinalFormatted || '-',
      horaFinal: this.trechoForm.horaPrevista || '-',
      tipoTrechoDescricao: selectedStretchType?.descricao || '-',
      pax: this.selectedProposalItem.quantidadePassageiros ?? passageiros.length,
    }

    const items = this.getStagedItems()
    items.push({ localId: Date.now().toString(), display, model })
    localStorage.setItem(this.localStorageKey, JSON.stringify(items))
    this.contractItems = items

    this.snackbar.success('Item adicionado à fila.')
    this.resetFormAfterCreate()
  }

  saveAllItems() {
    const items = this.getStagedItems()
    if (items.length === 0) return

    this.savingItem = true
    forkJoin(items.map(i => this.contractItemService.createContractItem(i.model))).subscribe({
      next: () => {
        this.snackbar.success(`${items.length} item(s) criado(s) com sucesso!`)
        localStorage.removeItem(this.localStorageKey)
        this.contractItems = []
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err) => {
        this.snackbar.errorRequest(err)
        this.savingItem = false
      },
    })
  }

  // ── Itens Logística (fila local) ──────────────────────────────────────────

  private get localStorageKey(): string {
    return `logistics_draft_${this.data.id}`
  }

  private getStagedItems(): any[] {
    const raw = localStorage.getItem(this.localStorageKey)
    return raw ? JSON.parse(raw) : []
  }

  loadContractItems() {
    this.contractItems = this.getStagedItems()
    this.contractItemTotalRows = this.contractItems.length
  }

  onContractItemPageEvent(event: PageEvent) {
    this.contractItemPage = event.pageIndex + 1
    this.contractItemRows = event.pageSize
  }

  deleteContractItem(item: any) {
    if (confirm('Deseja realmente remover este item da fila?')) {
      const items = this.getStagedItems().filter(i => i.localId !== item.localId)
      localStorage.setItem(this.localStorageKey, JSON.stringify(items))
      this.contractItems = items
      this.contractItemTotalRows = items.length
    }
  }

  editContractItem(item: any) {
    const dialogRef = this.dialog.open(ItemProposalCreateFormComponent, {
      data: {
        edit: true,
        item: item,
        idClient: this.data.idCliente,
        period: {
          dataInicio: this.data.dataInicio,
          dataFim: this.data.dataFim,
        },
      },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })

    dialogRef.componentInstance.response.subscribe((response: any) => {
      if (response) {
        this.loadingContractItems = true
        const model = {
          ...this.mapToExpectedModel(response),
          id: item.id,
          itemPropostaId: item.itemPropostaId ?? null,
        }
        this.contractItemService.editContractItem(model).subscribe({
          next: () => {
            this.snackbar.success('Item de logística atualizado com sucesso!')
            this.loadContractItems()
          },
          error: (err) => {
            console.error(err)
            this.snackbar.error('Não foi possível atualizar o item de logística.')
            this.loadingContractItems = false
          },
        })
      }
    })
  }

  mapToExpectedModel(response: any) {
    const passageiro: any[] = []
    return {
      contratoId: Number(this.data.id),
      itemPropostaId: response.itemPropostaId != null ? parseInt(response.itemPropostaId, 10) : null,
      tipoMotoristaId: response.tipoMotoristaId != null ? Number(response.tipoMotoristaId) : null,
      tipoVeiculoId: response.tipoVeiculoId != null ? Number(response.tipoVeiculoId) : null,
      origemId: Number(response.origemId) || 0,
      destinoId: Number(response.destinoId) || 0,
      tipoServicoId: response.tipoServicoId != null ? Number(response.tipoServicoId) : null,
      servicoId: response.servicoId != null ? Number(response.servicoId) : null,
      dataInicio: response.dataInicio ? moment(response.dataInicio, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : null,
      horaInicio: this.formatHora(response.horaInicio || ''),
      dataFinal: response.dataFinal ? moment(response.dataFinal, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : null,
      horaFinal: this.formatHora(response.horaFinal || ''),
      valorTarifario: null,
      valorProposta: this.parseVal(response.vendaSemTaxa),
      valorCompra: null,
      tipoTrechoId: response.tipoTrechoId != null ? Number(response.tipoTrechoId) : null,
      kmPrevisto: parseFloat(response.kmPrevisto) || 0,
      tempoPrevisto: response.tempoPrevisto || '0:00:00',
      observacao: response.observacao || '',
      passageiro,
      temPassageiro: 'N',
      itinerario: (response.intinerarios || []).map((iti: any) => ({
        contratoItemId: '00000000-0000-0000-0000-000000000000',
        localParada: iti.localParada || '',
        cep: iti.cep || '',
        logradouro: iti.logradouro || '',
        numero: iti.numero || '',
        bairro: iti.bairro || '',
        complemento: iti.complemento || '',
        descricao: iti.descricao || '',
        cidade: iti.cidade || '',
        estado: iti.estado || '',
        latitude: iti.latitude || 0,
        longitude: iti.longitude || 0,
        trecho: iti.trecho || '',
        areaTarifario: iti.areaTarifario || 'N',
      })),
    }
  }

  resetFormAfterCreate() {
    this.selectedPassengerIds.clear()
    this.itinerarios = []
    this.selectedProposalItem = null
    this.trechoForm = {
      dataInicio: '',
      dataFim: '',
      horaSaida: '',
      horaPrevista: '',
      tempoPrevisto: '',
      tipoTrechoId: null,
      tipoVeiculoId: null,
      tipoMotoristaId: null,
      kmPrevisto: null,
      observacao: '',
    }
  }

  private parseVal(value: any): number {
    if (typeof value === 'number') return value
    if (typeof value === 'string') {
      const n = parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
      return isNaN(n) ? 0 : n
    }
    return 0
  }

  criarItemEmergencial() {
    if (this.custoEmergencial === null) {
      this.snackbar.error('Informe o custo emergencial.')
      return
    }
    const dataInicioFormatted = this.trechoForm.dataInicio
      ? moment(this.trechoForm.dataInicio, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : null
    const dataFinalFormatted = this.trechoForm.dataFim
      ? moment(this.trechoForm.dataFim, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : null

    const model = {
      contratoId: this.data.id,
      itemPropostaId: 0,
      isEmergencial: true,
      custoEmergencial: this.custoEmergencial,
      tipoMotoristaId: this.trechoForm.tipoMotoristaId ?? null,
      tipoVeiculoId: this.trechoForm.tipoVeiculoId ?? null,
      origemId: 0,
      destinoId: 0,
      tipoServicoId: null,
      servicoId: null,
      tipoTrechoId: this.trechoForm.tipoTrechoId ?? null,
      dataInicio: dataInicioFormatted,
      dataFinal: dataFinalFormatted,
      horaInicio: this.formatHora(this.trechoForm.horaSaida),
      horaFinal: this.formatHora(this.trechoForm.horaPrevista),
      kmPrevisto: this.trechoForm.kmPrevisto ?? 0,
      tempoPrevisto: this.formatHora(this.trechoForm.tempoPrevisto),
      observacao: this.trechoForm.observacao || '',
      mostrarObsPdf: '',
      valorTarifario: 0,
      valorProposta: 0,
      valorCompra: 0,
      itinerario: this.itinerarios.map(iti => ({
        contratoItemId: '00000000-0000-0000-0000-000000000000',
        localParada: iti.local || '',
        cep: iti.cep || '',
        logradouro: iti.logradouro || '',
        numero: iti.numero || '',
        bairro: iti.bairro || '',
        complemento: '',
        cidade: iti.cidade || '',
        estado: '',
        latitude: 0,
        longitude: 0,
        trecho: iti.trecho || '',
        areaTarifario: 'N',
      })),
      passageiro: Array.from(this.selectedPassengerIds).map(id => ({ id })),
    }

    this.savingItem = true
    this.contractItemService.createContractItem(model).subscribe({
      next: (res: any) => {
        this.savingItem = false
        this.snackbar.success(res.message || 'Item emergencial criado com sucesso!')
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err: any) => {
        this.savingItem = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  private formatHora(hora: string): string {
    if (!hora) return ''
    // garante apenas HH:mm
    return hora.substring(0, 5)
  }
}
